import { ProductCategoryModel } from "../../models/products-category/ProductCategoryModel";
import { ApiBase } from "../../base/_ApiBase";

export const ProductCategoryApi = new class ProductCategoryApi extends ApiBase<ProductCategoryModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }
}({ baseUrl: '/products-category' });